// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"79":"business-home","149":"business-profile","464":"search"}[chunkId] + "." + {"79":"daa5ce5d723f17e73000","149":"e08da58d2940d21e7a33","464":"4e23d9656246e33cf7f0"}[chunkId] + ".bundle.js";
};